import React from "react";
import Paper from '@material-ui/core/Paper';
import Typography from "@material-ui/core/Typography";
import RateReviewIcon from '@material-ui/icons/RateReview';
import ListAltIcon from '@material-ui/icons/ListAlt';
import IconButton from "@material-ui/core/IconButton";
import Grid from '@material-ui/core/Grid';
import {
  createStyles,
  makeStyles,
  Theme
} from "@material-ui/core/styles";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: 0,
      display: 'flex',
      overflow: 'auto',
      margin: theme.spacing(1),
      flexDirection: 'column',
    },
    button: {
      borderRadius: "0",
      padding: 0
    },
    qaicon: {
      color: "white",
      backgroundColor: "DodgerBlue",
      width: "80px",
      height: "80px",
      minHeight: "1px",
    },
    buttontext: {
      padding: theme.spacing(1)
    },
    usericon: {
      color: "white",
      backgroundColor: "grey",
      width: "80px",
      height: "80px"
    },
    qalisticon: {
      color: "white",
      backgroundColor: "grey",
      width: "80px",
      height: "80px"
    }
  }))
interface Prop {
  handleListItemClick: (event: React.MouseEvent<HTMLElement, MouseEvent>, text: string) => void
}

//MenuIDを環境変数から取得
const menuQaCreate = process.env.REACT_APP_MENU_CR_QA_CREATE!
const menuQaList = process.env.REACT_APP_MENU_CR_QA_LIST!


const HomeMenu: React.FC<Prop> = (props) => {
  return (
    <React.Fragment>
      <Grid container justify="center" >
        <Grid item>
          <QaButton handleListItemClick={props.handleListItemClick} />
        </Grid>
        <Grid item>
          <QAListButton handleListItemClick={props.handleListItemClick} />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

const QaButton: React.FC<Prop> = (props) => {
  const classes = useStyles();
  const { handleListItemClick } = props
  const handleClickQa = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    handleListItemClick(event, menuQaCreate)
  }
  return (
    <Paper className={classes.paper}>
      <IconButton className={classes.button} onClick={handleClickQa}>
        <RateReviewIcon className={classes.qaicon} />
        <Typography className={classes.buttontext} variant="h6" component="h3" style={{ color: "DodgerBlue" }}>
          Q&A
          <br />
          新規登録
        </Typography>
      </IconButton>
    </Paper >
  )
}

const QAListButton: React.FC<Prop> = (props) => {
  const classes = useStyles();
  const { handleListItemClick } = props
  const handleClickList = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    handleListItemClick(event, menuQaList)
  }
  return (
    <Paper className={classes.paper}>
      <IconButton className={classes.button} onClick={handleClickList}>
        <ListAltIcon className={classes.qalisticon} />
        <Typography className={classes.buttontext} variant="h6" component="h3">
          Q&A一覧
          </Typography>
      </IconButton>
    </Paper>
  )
}


export default HomeMenu